








import Component, { mixins } from "vue-class-component";
import AxiosMixin from "../../mixins/axiosMixin";
import AttentionComponent from "@/components/app/Attention.vue";
import { Ref, Emit } from "vue-property-decorator";

@Component({
  components: {
    AttentionComponent
  }
})
export default class HonobonoInlineFrame extends mixins(AxiosMixin) {
  private url = "";
  private height = 0;

  mounted() {
    this.postJsonCheck(
      window.base_url + "/api/iframe_url/get",
      {
        id: 2
      },
      res => {
        this.url = res.data.announce.url;
        this.height = res.data.announce.height;
      }
    );
  }
}
